import React from 'react';

interface Props {
  title: string;
}

class LoginHeader extends React.Component<Props> {
  render() {
    return (
      <>
        <div style={{ fontSize: '24px' }}>Uitgekookt Logistics</div>
        <span style={{ fontSize: '16px' }}>{this.props.title}</span>
      </>
    );
  }
}

export default LoginHeader;
